<script setup>
    import {computed, onBeforeMount, ref} from "vue";
    import {glossaryStore} from "@pinia/glossary-store";
    import {apiFetch, updateLoading} from "@util/api";

    const {glossaryApi, glossaryLettersApi} = API
    const {title} = GLOSSARY?.filter;
    const store = glossaryStore()

    const letterIndex = computed(() => store.letterIndex)
    const query = computed(() => store.query)
    const letters = ref(GLOSSARY?.filter.letters || [])

    onBeforeMount(() => {
        apiFetch(glossaryLettersApi)
            .then(({data, status}) => status === 200 &&
                letters.value.forEach(letter => data[letter.label] && (letter.active = true))
            )
    })

    const selectLetter = (index) => {
        let letter = '';

        /**
         * If it's not the "All" option in whatever language,
         * then pull the letter based on the index and update
         * the store state
         */
        if (index !== 0) letter = letters.value[index].label

        store.$patch({
            letterIndex: index,
            letterSelected: letter,
            loading: true,
            query: {
                ...query.value,
                page: 1,
                letter,
            },
            results: [],
        })

        // Make API call here
        apiFetch(glossaryApi, query.value)
            .then(({data, status}) => status === 200 && store.$patch({
                results: data.results,
                total: data.total,
                maxPages: data.maxPages,
            }))
            .finally(() => updateLoading(store, false))

    }

</script>

<template>
    <div class="glossary-search__filter">
        <p
            class="browse"
            v-html="title"
        />

        <div
            v-if="letters.length"
            class="letter-filter"
        >
            <button
                v-for="({label, active}, index) in letters"
                :key="index"
                :class="{'active-letter': index === letterIndex, 'letter-disabled': !active}"
                :disabled="!active"

                @click="active && selectLetter(index)"
                v-html="label"
            />
        </div>
    </div>
</template>

<script>
    export default {
        name: "Glossary Filter"
    }
</script>

<style scoped lang="scss">
    .letter {
        &-filter {
            display: flex;
            justify-content: flex-start;
            margin-bottom: 20px;

            button {
                padding: 5px 10px;
            }
        }

        &-disabled {
            color: #aaa !important;
            cursor: not-allowed;
            pointer-events: none;
        }
    }
</style>
